import { Badge } from "@/components/ui/badge";

export const RiskBadge = ({ score }) => {
  if (score <= 30) {
    return (
      <Badge className="bg-green-500/10 text-green-500 border-green-500/20 text-[10px] cursor-default pointer-events-none">
        LOW
      </Badge>
    );
  }
  if (score <= 70) {
    return (
      <Badge className="bg-yellow-500/10 text-yellow-500 border-yellow-500/20 text-[10px] cursor-default pointer-events-none">
        MEDIUM
      </Badge>
    );
  }
  return (
    <Badge className="bg-red-500/10 text-red-500 border-red-500/20 text-[10px] cursor-default pointer-events-none">
      HIGH
    </Badge>
  );
};

export default RiskBadge;
